export default "__VITE_PUBLIC_ASSET__b032f1f3__"